exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-03e0f9d9]{text-align:justify;text-indent:.5em}img[data-v-03e0f9d9],video[data-v-03e0f9d9]{display:block;margin:.5em auto}.modal-dialog[data-v-03e0f9d9]{width:90vw!important;height:90vh!important;max-height:100%;max-width:100%}@media (min-width:800px){.modal-dialog[data-v-03e0f9d9]{width:750px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-03e0f9d9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ModalSettings.vue
// module id = 98
// module chunks = 0